let Popup     = require('../components/Popup');
let Accordion = require('../components/Accordion');

class Project {
    constructor() {
        this._bigNumber = document.getElementsByClassName('js-big-number');
        this._infos         = document.getElementsByClassName('js-logement');
        this._factors       = [-10, -10, -10];
        this._currentNumber = 0;
        this._image = document.getElementsByClassName('js-image-project-1')[0];

        this._changeNumber(this._infos[0]);

        this._createListener();

        this._createAccordion();

        new Popup('.js-project-know-more');
    }

    _createAccordion() {
        let accordions = document.getElementsByClassName('js-accordion');

        for (let accordion of accordions) {
            new Accordion(accordion);
        }
    }

    _createListener() {
        for (let info of this._infos) {
            info.addEventListener('click', () => {
                this._changeNumber(info);
                this._changeImage(info);
            });
        }
        for (let number of this._bigNumber) {
            number.addEventListener('animationend', () => {
                number.classList.remove('change');
            });
        }
    }

    _changeImage(info) {
        let image = info.getAttribute('data-image');

        this._image.style.backgroundImage = `url('${image}')`;
    }

    _changeNumber(info) {
        let dataNumber = info.getAttribute('data-number');
        let newNumber  = info.getElementsByTagName('span')[0].innerText;

        if (this._currentNumber !== newNumber) {
            this._currentNumber = newNumber;
            let numbers         = dataNumber.split('');
            let top             = 0;

            for (let i = 0; i < this._bigNumber.length; i++) {
                if (numbers[i] !== undefined) {
                    top = (this._factors[i] - parseInt(numbers[i])) * 2;

                    this._bigNumber[i].style.top = top + 'em';

                    this._bigNumber[i].classList.remove('hide');
                } else {
                    let currentTop = parseInt(this._bigNumber[i].style.top) / 2;
                    if (currentTop >= -30 && currentTop < -10) {
                        currentTop += 10;
                    } else {
                        currentTop -= 10;
                    }
                    top = (this._factors[i] + currentTop) * 2;
                    this._bigNumber[i].classList.add('hide');
                }

                this._bigNumber[i].style.top = top + 'em';

                this._bigNumber[i].classList.add('change');
            }

            if (this._factors[0] === -10) {
                this._factors = [0, -20, 0];
            } else {
                this._factors = [-10, -10, -10];
            }
        }
    }
}

module.exports = Project;